import Highlight, { defaultProps } from "prism-react-renderer";
import { useMaterialUIController } from "context";
import theme from "prism-react-renderer/themes/github";
import themeDark from "prism-react-renderer/themes/dracula";
import { Pre, Line, LineNo, LineContent } from "./styles";
import PropTypes from "prop-types";

function HighlightedCode(props) {
  // Fetch Color Modes
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  return (
    <>
      {props?.enableNumbering ? (
        <Highlight
          {...defaultProps}
          theme={theme}
          code={props.code}
          language="javascript"
        >
          {({ className, style, tokens, getLineProps, getTokenProps }) => (
            <Pre className={className} style={style}>
              {tokens.map((line, i) => (
                <Line key={line} {...getLineProps({ line, key: i })}>
                  <LineNo>{i + 1}</LineNo>
                  <LineContent>
                    {line.map((token, key) => (
                      <span key={token} {...getTokenProps({ token, key })} />
                    ))}
                  </LineContent>
                </Line>
              ))}
            </Pre>
          )}
        </Highlight>
      ) : (
        <Highlight
          {...defaultProps}
          theme={darkMode ? themeDark : theme}
          code={props.code}
          language="jsx"
        >
          {({ className, style, tokens, getLineProps, getTokenProps }) => (
            <Pre className={className} style={style}>
              {tokens.map((line, i) => (
                <div {...getLineProps({ line, key: i })}>
                  {line.map((token, key) => (
                    <span {...getTokenProps({ token, key })} />
                  ))}
                </div>
              ))}
            </Pre>
          )}
        </Highlight>
      )}
    </>
  );
}

HighlightedCode.propTypes = {
  enableNumbering: PropTypes.bool,
  code: PropTypes.string.isRequired,
};
export default HighlightedCode;
